export enum UserRoleValues {
  ADMIN = "ADMIN",
  VIEWER = "VIEWER",
  TEMPORARY = "TEMPORARY",
}
